/**
 * Status and Role utility functions
 * Provides consistent color mapping for status and user roles across the application
 */

import { USER_STATUS_OPTIONS, USER_ROLE_OPTIONS, getUserStatusDisplayName, getUserRoleDisplayName } from './formConstants';

/**
 * Get color theme key for user status
 * @param {string} status - Status value (ACTIVE, INACTIVE, SUSPENDED, IDLE)
 * @returns {string} - Color theme key (success, error, warning, info)
 */
export const getStatusColor = (status) => {
    switch (status) {
        case USER_STATUS_OPTIONS.ACTIVE:
            return "success";
        case USER_STATUS_OPTIONS.INACTIVE:
            return "error";
        case "SUSPENDED":
            return "warning";
        case USER_STATUS_OPTIONS.IDLE:
            return "warning";
        default:
            return "info";
    }
};

/**
 * Get color theme key for user role
 * @param {string} role - User role value
 * @returns {string} - Color theme key (primary, info, warning, success, dark)
 */
export const getUserRoleColor = (role) => {
    switch (role) {
        case USER_ROLE_OPTIONS.SYSTEM_ADMIN:
            return "dark";
        case USER_ROLE_OPTIONS.ADMIN:
            return "primary";
        case USER_ROLE_OPTIONS.BRANCH_ADMIN:
            return "info";
        case USER_ROLE_OPTIONS.COMPANY_ADMIN:
            return "info";
        case USER_ROLE_OPTIONS.STAFF:
            return "success";
        case USER_ROLE_OPTIONS.GUARDIAN:
            return "warning";
        default:
            return "info";
    }
};

/**
 * Get display name for status
 * @param {string} status - Status value
 * @returns {string} - Display name
 */
export const getStatusDisplayName = (status) => {
    return getUserStatusDisplayName(status) || status || 'N/A';
};

/**
 * Get display name for user role
 * @param {string} role - User role value
 * @returns {string} - Display name
 */
export const getRoleDisplayName = (role) => {
    return getUserRoleDisplayName(role) || role?.replace('_', ' ') || 'N/A';
};

